import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { bindActionCreators } from 'redux';

import {
    EXTRACT_TEMPLATE_MODULES,
    FILE_NAME_TEMPLATE,
    UPLOAD_TYPES,
    MODAL_CUSTOM_MESSAGE,
    DOWNLOAD_TEMPLATE_lABEL,
    ARTICLE_UPLOAD_TYPES,
    ARTICLE_UPLOAD_TYPE_MESSAGE,
    ARTICLE_UPLOAD_FILE_LIMITATIONS
} from '../../../../../constants/external-constants';
import Translation from '../../../../common/translation/translation.component';
import DragDropUpload from '../../../../common/upload/drag-drop-upload/drag-drop-upload.component';
import { SelectFieldFloatingLabel as Select } from '../../../../common/custom-form/select-filter.component';
import { Loading } from '../../../../common/loading/index';
import { ArticleUploadTypeAction } from '../../../../../store/external/recharge-reducer/article-upload-reducer/article-upload.reducer';
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import { validateAccessModule } from '../../../../../utils/helpers.utils';
import { ACCESS_MODULE, MATRIX_INDICATOR } from '../../../../../utils/rbac-constants.utils';

class ArticleUpload extends Component {
    constructor(props) {
        super(props);
        this.childRef = React.createRef();
        this.state = {
            vendor: null,
            extractAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            uploadInProgress: false,
            isLoading: true,
            filterLoading: false,
            loadingLabel: "",
            errorModal: {
                show: false,
                title: "",
                message: ""
            },
        };
    }
    async componentDidMount() {
        const { getArticleUploadTypes, resetArticleUploadForm } = this.props;

        await resetArticleUploadForm();
        await getArticleUploadTypes().then(() => { this.setState({ isLoading: false }) });
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    dropDragDisable = () => {
        const { articleUploadForm } = this.props;
        const requiredField = !articleUploadForm.articleUploadTypeId

        return requiredField;
    }

    handleDownloadTemplate = () => {
        const { downloadArticleCatalogueTemplate } = this.props;
        this.setState({
            filterLoading: true,
            loadingLabel: "Downloading"
        })
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            downloadArticleCatalogueTemplate(EXTRACT_TEMPLATE_MODULES.articleCatalogueTemplate, FILE_NAME_TEMPLATE.articleCatalogueTemplate).then(() => {
                this.setState({
                    filterLoading: false,
                    loadingLabel: ""
                })
            });;
        } else {
            this.setState({
                filterLoading: false,
                loadingLabel: ""
            })
        }
    }

    handleSuccessProcess = (data) => {
        const { postExecuteProcess, resetArticleUploadForm } = this.props;
        postExecuteProcess(data.UploadId);
        this.setState({
            uploadInProgress: false
        });

        resetArticleUploadForm();
    }

    handleAddFiles = () => {
        this.forceUpdate();
    }

    handleRemoveFiles = () => {
        this.forceUpdate();
    }

    djsConfigParams = () => {
        const { articleUploadForm } = this.props;

        var baseParams = {
            ArticleUploadTypeId: articleUploadForm.articleUploadTypeId
        };
        var djsConfig = {
            params: {
                CreatedBy: sessionStorage.getItem('EID').toString(),
                UserId: sessionStorage.getItem('UserID').toString(),
                UploadTypeId: UPLOAD_TYPES.ArticleUpload,
                ChargeTypeDetails: JSON.stringify({
                    ...baseParams,
                }),
            },
            maxFiles: ARTICLE_UPLOAD_FILE_LIMITATIONS.maxFiles,
            minFiles: ARTICLE_UPLOAD_FILE_LIMITATIONS.minFiles,
            acceptedFiles: ARTICLE_UPLOAD_FILE_LIMITATIONS.acceptedFiles,
            dictInvalidFileType: this.toLocaleLanguage('error_invalid_file_type'),
            dictMaxFilesExceeded: this.toLocaleLanguage('error_exceeded_maximum_file'),
            dictErrorOccured: this.toLocaleLanguage('error_occured_reupload_file')
        };
        return djsConfig;
    }
    disabledUpload = () => {
        const { articleUploadForm } = this.props;
        const intialField = !(!articleUploadForm.articleUploadTypeId);

        let validFiles = false;
        if (this.childRef.current) {
            validFiles = this.childRef.current.checkValidFileForm();
        }

        return !(intialField && validFiles);

    }
    handleUpload = () => {
        if (this.childRef.current) {
            this.childRef.current.processQueue();
        }
        this.setState({
            uploadInProgress: true
        });
    }
    onErrorUpload = () => {
        this.setState({
            uploadInProgress: false
        })
    }
    render() {
        const { articleUploadTypeOptions } = this.props.articleUpload;
        const { articleUploadForm, onArticleUploadTypeSelect } = this.props;

        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingArticleCatalogueDashboardRW])
        return (
            <div className="rate-card-upload upload__container ">
                {
                    this.state.filterLoading &&
                    <Loading customClass="filter-loading" label={this.state.loadingLabel} />
                }
                <div className="invoice-mapping-container">
                    <div className="field-section">
                        <div className="field-content">
                            <Translation
                                getOnlyText={true}
                                onChangeTranslation={this.onChangeExtractAlertMsg}
                                translationKey={"export_alert_message"} />

                            <div className="spacer" />
                            <Select
                                className="form-select required"
                                label={`${this.toLocaleLanguage('upload_type')}`}
                                value={articleUploadForm.articleUploadTypeId ?? ""}
                                options={articleUploadTypeOptions}
                                fieldProp='articleUploadForm.articleUploadTypeId'
                                onChangeAction={onArticleUploadTypeSelect}
                                placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                optionLabelKey={{
                                    Key: "Key",
                                    Value: "Value"
                                }}
                                disabled={!isReadAndWrite}
                            />

                            {articleUploadForm.articleUploadTypeId === ARTICLE_UPLOAD_TYPES.New ?
                                <span className="pending-upload-message">{ARTICLE_UPLOAD_TYPE_MESSAGE.New}</span> : null
                            }

                            {articleUploadForm.articleUploadTypeId === ARTICLE_UPLOAD_TYPES.AddUpdate ?
                                <span className="pending-upload-message">{ARTICLE_UPLOAD_TYPE_MESSAGE.AddUpdate}</span> : null
                            }

                            <div className="spacer" />
                        </div>
                    </div>
                    <div className="upload-section">
                        <div className="upload-content">
                            <DragDropUpload
                                ref={this.childRef}
                                buttonLabel={DOWNLOAD_TEMPLATE_lABEL.article_catalogue}
                                disabled={this.dropDragDisable() || !isReadAndWrite }
                                downloadButton={this.handleDownloadTemplate}
                                djsConfigParams={this.djsConfigParams()}
                                onSuccessProcess={this.handleSuccessProcess}
                                onAddFiles={this.handleAddFiles}
                                onRemoveFiles={this.handleRemoveFiles}
                                uploadTypeId={UPLOAD_TYPES.ArticleUpload}
                                onErrorUpload={this.onErrorUpload}
                            />
                        </div>
                    </div>
                    <div className="upload-btn-section">
                        <div className="save-btn-container">
                            <Button disabled={this.disabledUpload() || this.state.uploadInProgress || !isReadAndWrite} onClick={this.handleUpload} className="save-details-btn">Upload</Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        const { translation
            , articleUpload } = state;

        const { articleUploadForm } = state.form;
        return {
            ...translation
            , articleUpload
            , articleUploadForm
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, ArticleUploadTypeAction),
        dispatch
    )
)(ArticleUpload);